import { AxiosError } from 'axios';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useSessionUser } from '../contexts/SessionUserContext';
import { useWhoami } from '../queries/authentication';

export const Whoami = () => {
  const { updateUserId, setInitialQueryFinished } = useSessionUser();
  const navigate = useNavigate();
  const location = useLocation();

  const whoamiQuery = useWhoami();

  useEffect(() => {
    if (whoamiQuery.isSuccess) {
      const whoamiData = whoamiQuery.data;
      updateUserId(whoamiData.userId);
      setInitialQueryFinished(true);
    } else if (whoamiQuery.isError) {
      const error = whoamiQuery.error;

      if (error instanceof AxiosError && error.response?.status === 401) {
        // User is not authenticated
        updateUserId(null);
        setInitialQueryFinished(true);

        // Only redirect to login if not already on an auth route
        // This prevents interfering with login, logout, and magic-link flows
        const isAuthRoute = location.pathname.startsWith('/auth/');
        if (!isAuthRoute) {
          void navigate('/auth/login');
        }
      } else {
        // Other errors - still mark as finished but keep current state
        setInitialQueryFinished(true);
      }
    }
  }, [
    whoamiQuery.isSuccess,
    whoamiQuery.isError,
    whoamiQuery.data,
    whoamiQuery.error,
    updateUserId,
    setInitialQueryFinished,
    navigate,
    location.pathname,
  ]);

  // This component doesn't render anything - it just manages auth state
  return null;
};

export default Whoami;
